import { AxiosInstance } from "axios";
import { ResponseDto } from "@common/ict/model/interface/common";

export class PubBiddingApi {
  static getPubBiddingList(request: AxiosInstance, params) {
    return request.get<ResponseDto, ResponseDto>(
      "zh-business/client/v1/pub/bidding/page/list",
      {
        params
      }
    );
  }

  static getPubBiddingDetail(request: AxiosInstance, params) {
    return request.get<ResponseDto, ResponseDto>(
      "zh-business/client/v1/pub/bidding/detail",
      {
        params
      }
    );
  }

  static getPubBiddingDetailFull(request: AxiosInstance, params) {
    return request.get<ResponseDto, ResponseDto>(
      "zh-business/client/v1/pub/bidding/detail/full",
      {
        params
      }
    );
  }

  static getPubBiddingCarousel(request: AxiosInstance, params) {
    return request.get<ResponseDto, ResponseDto>(
      "zh-business/client/v1/pub/bidding/carousel",
      { params: params }
    );
  }

  static getPubBiddingNumber(request: AxiosInstance) {
    return request.get<ResponseDto, ResponseDto>(
      "zh-business/client/v1/pub/bidding/number"
    );
  }

  static submitPubBiddingApply(request: AxiosInstance, params) {
    return request.post<ResponseDto, ResponseDto>(
      "/zh-business/client/v1/pub/bidding/apply/submit",
      params
    );
  }

  static downloadFile(request: AxiosInstance, data) {
    return request.get<ResponseDto, ResponseDto>(
      "/zh-business/client/v1/pub/bidding/apply/file/download",
      {
        params: data,
        headers: {
          "Content-type": "multipart/form-data"
        },
        responseType: 'blob'
      }
    );
  }
}